import { useBlockSubscription } from '@bechtel/client-blocks';
import { CrewChangeSubscriptionContext } from '@bechtel/client-common';
import { useCrewChangeSubscription, useCrewUpdateSubscription } from '@bechtel/client-crew-change';
import { useSyncNotificationSubscription, useWorkPackagesImportSubscription } from '@bechtel/client-project-admin';
import { useCommoditySubscription, useWorkPackageSubscription } from '@bechtel/client-work-packages';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { WPImportStatusSubscriptionContext } from '../wp-import-status-subscription-context';

export const SubscriptionManager: FC<any> = ({ children }) => {
  const location = useLocation();
  useWorkPackageSubscription();
  useCommoditySubscription();
  useBlockSubscription();
  useSyncNotificationSubscription();
  const [crewChangeRequestId, setCrewChangeRequestId] = useCrewChangeSubscription();
  const [affectedCrewMembers, setAffectedCrewMembers] = useCrewUpdateSubscription();
  const [workPackageImportStatus, setWorkPackageImportStatus] = useWorkPackagesImportSubscription();
  useEffect(() => {
    const pathName = location.pathname;
    if (pathName && pathName.includes('/crew-change')) setCrewChangeRequestId('');
  }, [location]);

  //Only created id's will be passed. Updates are handled in local cache call

  return (
    <>
      <CrewChangeSubscriptionContext
        crewChangeRequestId={crewChangeRequestId}
        setCrewChangeRequestId={setCrewChangeRequestId}
        affectedCrewMembers={affectedCrewMembers}
        setAffectedCrewMembers={setAffectedCrewMembers}
      >
        <WPImportStatusSubscriptionContext
          workPackageImportStatus={workPackageImportStatus}
          setWorkPackageImportStatus={setWorkPackageImportStatus}
        ></WPImportStatusSubscriptionContext>
        {children}
      </CrewChangeSubscriptionContext>
    </>
  );
};
